import React, { ChangeEvent, useEffect, useState } from "react";
import styles from "./styles.module.scss";
import Separator from "src/components/separator";
import { useAppDispatch, useAppSelector } from "src/hooks/useRedux";
import {
  setCurrentState,
  setFirstSectionValid,
} from "src/redux/slices/appSlice/AppSlice";
import {
  UIButton,
  UIText,
  FloatingLabelInput,
  UICheckBox,
} from "src/components/uIKit";
import UserInfoBanner from "src/components/userInfoBanner";
import { useForm, Controller, FormProvider } from "react-hook-form";
import ErrorMessage from "src/components/errorMessage";
import getValidationRules from "src/validations/ValidationRules";
import {
  API_RESULT,
  AUTOCOMPLETE,
  INPUT_TYPE,
  ROUTES,
  STATE,
  TEXT_TAGS,
  URL_SOURCE_TYPE,
  POPUP_TYPE,
  IDS,
  CHECKBOX_TYPE,
  INPUT_LENGTH,
} from "src/utils/enums";
import {
  __DEV__,
  formatPhoneNumber,
  isEnsureOrPfsRepOrPfsRepManual,
  logPfsAnalyticsEvent,
} from "src/utils/utils";
import { setPopupInfo } from "src/redux/slices/popupSlice/popupSlice";
import {
  StreetAndCityResponse,
  UpdateOnboardingAnalytics,
} from "src/utils/types";
import { images } from "src/assets/images/images";

import {
  setSelectedCity,
  setSelectedStreet,
  setUserInfo,
  setZipCode,
} from "src/redux/slices/userSlice/UserSlice";
import {
  fetchAddressSuggestions,
  updatePersonalDetails,
  updateZipCode,
} from "src/redux/slices/userSlice/UserApi";
import {
  fetchCitySuggestions,
  fetchZipCode,
} from "src/redux/slices/userSlice/UserApi";
import {
  EXTERNAL_URL,
  GLOBAL_BLUE_PRIVACY_POLICY_LINK,
  GLOBAL_BLUE_THIRD_PARTY_LINK,
} from "src/utils/consts";
import { useNavigate } from "react-router-dom";
import { useRouteParams } from "src/hooks/useRouteParams";
type FormInputs = {
  email: string;
  address: string;
  zip: string;
  city: string;
  apartment: string;
};

const UpdateContactDetails: React.FC = () => {
  const navigate = useNavigate();
  const { currentSource } = useRouteParams();
  const [phone, setPhone] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [citiesResults, setCitiesResults] = useState<StreetAndCityResponse[]>(
    []
  );
  const [streetsResults, setStreetsResults] = useState([]);
  const [cityLoading, setCityLoading] = useState<boolean | null>(null);
  const [addressLoading, setAddressLoading] = useState<boolean | null>(null);

  const methods = useForm<FormInputs>({
    defaultValues: {
      email: "",
      address: "",
      zip: "",
      city: "",
      apartment: "",
    },
  });

  const dispatch = useAppDispatch();
  const { strings, hostUrl, businessUnit, personalId, currentState } =
    useAppSelector((state) => state.app);
  const [emailNotValidText, setEmailNotValidText] = useState("");

  const nextStepText =
    strings.acc_t_tax_refaund_next +
    " " +
    strings.t_towards_step +
    " " +
    strings.t_benefits_enable_card;
  const {
    citiesResStatus,
    cities,
    streetsResStatus,
    streets,
    selectedCity,
    selectedStreet,
    zipCodeResStatus,
    zipCode,
    personalDetailsRes,
    updatePersonalDetailsResStatus,
  } = useAppSelector((state) => state.user);
  const validationRules = getValidationRules(strings);

  useEffect(() => {
    dispatch(setCurrentState(STATE.UPDATE_CONTACT_DETAILS));
  }, []);

  useEffect(() => {
    const tempPhone =
      personalDetailsRes?.feCustAreaCode + personalDetailsRes?.feCustPhone;
    const formatedPhone = formatPhoneNumber(tempPhone || "");

    setPhone(formatedPhone);

    // Set email from personalDetailsRes
    if (personalDetailsRes?.feCustEmail) {
      methods.setValue("email", personalDetailsRes.feCustEmail);
    }
    if (personalDetailsRes?.feCustCity) {
      methods.setValue("city", personalDetailsRes.feCustCityName);


      dispatch(
        setSelectedCity({
          name: personalDetailsRes.feCustCityName,
          id: personalDetailsRes.feCustCity,
        })
      );
    }
    if (personalDetailsRes?.feCustStreet) {
      methods.setValue("address", personalDetailsRes.feCustStreetName);
      setTimeout(() => {
        dispatch(
          setSelectedStreet({
            name: personalDetailsRes.feCustStreetName,
            id: personalDetailsRes.feCustStreet,
          })
        );
      }, 1000);
    }
    if (personalDetailsRes?.feCustPostalCode) {
      setTimeout(() => {
        methods.setValue("zip", personalDetailsRes?.feCustPostalCode);
      }, 1000);
    }
    if (personalDetailsRes?.feCustHouseNumber) {
      setTimeout(() => {
        methods.setValue(
          "apartment",
          personalDetailsRes.feCustHouseNumber.toString()
        );
      }, 1000);
    }
    // if (personalDetailsRes?.fePFSmarketingMailing) {
    if (!isEnsureOrPfsRepOrPfsRepManual(currentSource)) { // Bugs 4383 fix , bugs 4592 fix

      setIsChecked(personalDetailsRes?.fePFSmarketingMailing === null || personalDetailsRes?.fePFSmarketingMailing === true);
    }
    // }

    if (hostUrl === URL_SOURCE_TYPE.DIGITAL_AGENT) {
      dispatch(
        setPopupInfo({
          show: true,
          type: POPUP_TYPE.DIGITAL_AGENT,
          title: strings.t_digiral_agent_title,
          body: strings.t_digiral_agent_body,
          img: images.image1,
          mobileImg: images.image1Mobile,
          strings,
          hideCloseBtn: true,
        })
      );
    }
  }, [personalDetailsRes]);

  useEffect(() => {
    const { email, address, apartment, city } = methods.getValues();
    setButtonDisabled(
      email.trim() === "" ||
      emailNotValidText !== "" ||
      address.trim() === "" ||
      apartment.trim() === "" ||
      city.trim() === "" ||
      selectedCity.id === "" ||
      selectedStreet.id === "" ||
      apartment.trim() === ""
    );
  }, [methods.watch()]);

  useEffect(() => {
    if (citiesResStatus === API_RESULT.SUCCEEDED) {
      setCitiesResults(cities);
      setCityLoading(false);
    } else if (citiesResStatus === API_RESULT.LOADING) {
      setCityLoading(true);
    }
  }, [citiesResStatus]);

  useEffect(() => {
    if (streetsResStatus === API_RESULT.SUCCEEDED) {
      setStreetsResults(streets);
      setAddressLoading(false);
    } else if (streetsResStatus === API_RESULT.LOADING) {
      setAddressLoading(true);
    }
  }, [streetsResStatus]);

  useEffect(() => {
    if (zipCodeResStatus === API_RESULT.SUCCEEDED) {
      setButtonDisabled(false);
      console.log("zipCode", zipCode);
      console.log("zipCode.trim().length", zipCode.trim().length);
      if (zipCode) {
        if (zipCode.trim().length !== 7) {
          methods.setValue("zip", "");
        } else {
          methods.setValue("zip", zipCode);
        }
      } else {
        methods.setValue("zip", "");
      }
    } else if (zipCodeResStatus === API_RESULT.LOADING) {
      setButtonDisabled(true);
    }
  }, [zipCodeResStatus]);

  useEffect(() => {
    if (updatePersonalDetailsResStatus === API_RESULT.SUCCEEDED) {

      if (methods.getValues("zip")) {
        dispatch(updateZipCode({
          feCustCity: selectedCity.name,
          feCustStreet: selectedStreet.name,
          feCustStreetNumber: Number(methods.getValues("apartment")),
          feCustPostalCode: methods.getValues("zip"),
        }));
      }
      dispatch(setFirstSectionValid(true));
      navigate("/" + hostUrl + "/" + ROUTES.ACTIVATE_CREDIT_CARD);

    }
  }, [updatePersonalDetailsResStatus]);
  const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
    setIsChecked(event.target.checked);
  };

  const onSubmit = (data: any) => {

    dispatch(setCurrentState(STATE.ACTIVATE_CREDIT_CARD));
    const updatePersonalDetailsData = {
      // ...(!isEnsureOrPfsRepOrPfsRepManual(currentSource) && { fePFSMarketingMailing: isChecked }),
      fePFSMarketingMailing: !isEnsureOrPfsRepOrPfsRepManual(currentSource) ? isChecked : true,
      feCustPersId: personalId,
      feCustEmail: data.email,
      feCustPostalCode: data.zip,
      feBU: businessUnit,
      feCustCity: selectedCity.id,
      feCustStreet: selectedStreet.id,
      feHouseNumber: Number(data.apartment),
    };

    dispatch(updatePersonalDetails(updatePersonalDetailsData));
    dispatch(setUserInfo(data));
  };

  const fetchCitiesSuggestions = async (input: string) => {
    setCityLoading(true);
    try {
      dispatch(fetchCitySuggestions({ cityName: input.trim() }));
    } catch (error) {
      console.error(error);
    } finally {
      setCityLoading(false);
    }
  };
  const fetchStreetsSuggestions = async (input: string) => {
    setAddressLoading(true);
    try {
      const body = {
        streetName: input.trim(),
        cityId: selectedCity.id,
      };
      dispatch(fetchAddressSuggestions(body));
    } catch (error) {
      console.error(error);
    } finally {
      setAddressLoading(false);
    }
  };
  const fetchZeepSuggestions = async (input: string) => {
    setAddressLoading(true);
    try {
      const body = {
        cityNameHebrew: selectedCity.name,
        streetNameHebrew: selectedStreet.name,
        houseNumber: Number(input.trim()) || 0,
      };
      dispatch(fetchZipCode(body));
    } catch (error) {
      console.error(error);
    } finally {
      setAddressLoading(false);
    }
  };

  const clearApartment = () => {
    // clean apartment from react-hook-form
    methods.setValue("apartment", "");
  };
  const clearZip = () => {
    // clean zip code from react-hook-form
    methods.setValue("zip", "");
    dispatch(setZipCode(""));
  };
  const clearCity = () => {
    // Clear city and its dependent fields
    methods.setValue("city", "");
    methods.setValue("address", "");
    methods.setValue("zip", "");
    methods.setValue("apartment", "");
    dispatch(setZipCode(""));
  };
  const clearAddress = () => {
    // Clear address and its dependent fields
    methods.setValue("address", "");
    methods.setValue("zip", "");
    methods.setValue("apartment", "");
    dispatch(setZipCode(""));
  };
  const handleEditPhoneClick = () => {
    // go to external link
    window.open(
      `${EXTERNAL_URL}/SelfService/?goto=UpdatePersonalDetails`,
      "_blank"
    );
  };
  const handleEditEmailClick = (value: string) => {
    // Just set the value without validation
    methods.setValue("email", value);
  };
  const handleEmailBlur = (value: string) => {
    // Email validation regex
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

    if (!value || !emailRegex.test(value)) {
      setEmailNotValidText(strings.t_update_contact_email_not_valid);
      setButtonDisabled(true);
    } else {
      setEmailNotValidText(""); // Clear error if email is valid
      setButtonDisabled(false);
    }
  };
  // const renderPolicyText = () => {
  //   const parts = strings.t_global_blue_checkbox_text?.split(
  //     /(ספק צד שלישי|מדיניות הפרטיות והשימוש)/
  //   );
  //   return parts?.map((part, index) => {
  //     if (part === "ספק צד שלישי") {
  //       return (
  //         <a
  //           key={index}
  //           href={GLOBAL_BLUE_THIRD_PARTY_LINK}
  //           target="_blank"
  //           rel="noopener noreferrer"
  //         >
  //           {part}
  //         </a>
  //       );
  //     }
  //     if (part === "מדיניות הפרטיות והשימוש") {
  //       return (
  //         <a
  //           key={index}
  //           href={GLOBAL_BLUE_PRIVACY_POLICY_LINK}
  //           target="_blank"
  //           rel="noopener noreferrer"
  //         >
  //           {part}
  //         </a>
  //       );
  //     }
  //     return part; // Render normal text
  //   });
  // };
  return (
    <FormProvider {...methods}>
      <div className={styles.container}>
        <UIText
          text={strings.t_update_contact_main_title}
          size={18}
          weight={400}
          style={styles.title}
        />
        <UserInfoBanner
          title={(personalDetailsRes?.feCustFirstNameHeb && personalDetailsRes?.feCustLastNameHeb)
            ? personalDetailsRes.feCustFirstNameHeb + " " + personalDetailsRes.feCustLastNameHeb
            : ""}
          subTitle={strings.t_fullName}
          ariaLabel={strings.t_fullName}
          icon={images.updateUser}
          onEdit={() => { }}
        />
        <br />
        <UserInfoBanner
          title={phone}
          subTitle={strings.t_update_contact_phone}
          // editText={strings.t_update_contact_edit}
          ariaLabel={strings.t_update_contact_phone_edit}
          icon={images.phoneIcon}
          onEdit={handleEditPhoneClick}
        />
        <br />
        <UserInfoBanner
          title={methods.getValues("email")}
          subTitle={strings.t_update_contact_email_title_wrapper}
          editText={strings.t_update_contact_edit}
          ariaLabel={strings.t_update_contact_email_title_wrapper}
          icon={images.emailIcon}
          onEdit={handleEditEmailClick}
          onBlur={handleEmailBlur}
        />
        {emailNotValidText && (
          <ErrorMessage
            style={styles.errorStyleEmail}
            message={emailNotValidText}
          />
        )}

        <Separator />
        <section>
          <UIText
            text={strings.t_update_contact_email_title}
            ariaLabel={strings.acc_t_update_contact_email_title}
            tag={TEXT_TAGS.H3}
            size={20}
            weight={500}
            style={styles.emailTitle}
          />
          <UIText
            text={strings.t_why_we_need_adress}
            ariaLabel={strings.acc_t_why_we_need_adress}
            size={18}
            weight={400}
            style={styles.title}
          />
          <fieldset>
            <FloatingLabelInput
              label={strings.t_city}
              ariaLabel={strings.acc_t_city}
              name="city"
              autoCompleteType={AUTOCOMPLETE.CITY}
              results={citiesResults}
              loading={cityLoading}
              fetchSuggestions={fetchCitiesSuggestions}
              resStatus={citiesResStatus}
              crearByInput={clearCity}
              isMandatory={true}
            />

            <FloatingLabelInput
              label={strings.t_update_contact_address_placeholder}
              ariaLabel={strings.acc_t_update_contact_address_placeholder}
              name="address"
              autoCompleteType={AUTOCOMPLETE.ADDRESS}
              results={streetsResults}
              loading={addressLoading}
              fetchSuggestions={fetchStreetsSuggestions}
              disabled={Object.keys(selectedCity).length === 0}
              resStatus={streetsResStatus}
              crearByInput={clearAddress}
              isMandatory={true}
            />

            <div className={styles.row}>
              <Controller
                name="apartment"
                rules={validationRules.apartment}
                render={({ field, fieldState: { error } }) => (
                  <div className={styles.flexColumn}>
                    <FloatingLabelInput
                      label={strings.t_apartment}
                      debounceLength={1}
                      crearByInput={clearApartment}
                      ariaLabel={strings.acc_t_apartment}
                      {...field}
                      autoCompleteType={AUTOCOMPLETE.HOUSE_NUMBER}
                      disabled={
                        Object.keys(selectedStreet).length === 0 ||
                        Object.keys(selectedCity).length === 0
                      }
                      fetchSuggestions={fetchZeepSuggestions}
                      type={INPUT_TYPE.TEL}
                      {...(error
                        ? {
                          errorDescribedBy:
                            IDS.CONTACT_DETAILS_APARTMENT_ERROR_MESSAGE,
                        }
                        : {})}
                    />
                    <ErrorMessage
                      id={IDS.CONTACT_DETAILS_APARTMENT_ERROR_MESSAGE}
                      style={styles.errorStyleAdress}
                      message={error?.message}
                    />
                  </div>
                )}
              />
              <Controller
                name="zip"
                rules={validationRules.zip}
                render={({ field, fieldState: { error } }) => (
                  <div className={styles.flexColumn}>
                    <FloatingLabelInput
                      label={strings.t_update_contact_zip}
                      crearByInput={clearZip}
                      ariaLabel={strings.acc_t_update_contact_zip}
                      {...field}
                      style={styles.zipInput}
                      // readOnly={(zipCode.trim().length === 7) ||
                      //   (zipCode.trim().length !== 7 && zipCode.length !== zipCode.trim().length &&
                      //     zipCode !== undefined &&
                      //     zipCode !== "")}
                      readOnly={zipCode.trim().length === 7}
                      loading={zipCodeResStatus === API_RESULT.LOADING}
                      autoCompleteType={AUTOCOMPLETE.ZIP}
                      maxLength={INPUT_LENGTH.ZIP}
                      {...(error
                        ? {
                          errorDescribedBy:
                            IDS.CONTACT_DETAILS_ZIP_ERROR_MESSAGE,
                        }
                        : {})}
                    />
                    <ErrorMessage
                      id={IDS.CONTACT_DETAILS_ZIP_ERROR_MESSAGE}
                      style={styles.errorStyleZip}
                      message={error?.message}
                    />
                  </div>
                )}
              />
            </div>
          </fieldset>
        </section>
        {!isEnsureOrPfsRepOrPfsRepManual(currentSource) && (
          <div>
            <Separator />
            {/* <UICheckBox
              text={renderPolicyText() as string}
              checked={isChecked}
              onChange={handleCheckboxChange}
            /> */}
            <div className={styles.checkBoxWrapper}>
              <UICheckBox
                checked={isChecked}
                onChange={handleCheckboxChange}
                type={CHECKBOX_TYPE.SQUARE}
              />
              <UIText text={strings.t_update_contact_checkbox_text} size={18} weight={400} />
            </div>
          </div>
        )}
        <section>
          <div className={styles.buttonWrapepr}>
            <UIButton
              ariaLabel={nextStepText}
              title={strings.t_update_contact_save}
              onSubmit={methods.handleSubmit(onSubmit)}
              disabled={buttonDisabled || zipCodeResStatus === API_RESULT.LOADING}
              isLoading={updatePersonalDetailsResStatus === API_RESULT.LOADING || zipCodeResStatus === API_RESULT.LOADING}
            />
          </div>
        </section>
      </div>
    </FormProvider>
  );
};

export default UpdateContactDetails;
